/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 4/20/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */
import http from "@/utils/http";
const url = action => `/sync/util/${action[0]}`;

export default class UTIL {
  static OPTIONS(params) {
    return http.get(url`options`, { params });
  }
  static SCHEMAS(params) {
    return http.get(url`schemas`, { params });
  }
  static MANAGERS(params) {
    return http.get(url`managers`, { params });
  }
  static DESCRIPTORS(params) {
    return http.get(url`descriptors`, { params });
  }
  static EXTENSIONS(params) {
    return http.get(url`extensions`, { params });
  }
}
